import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http } from '../../utils/config';

const initialState = {
    listBotav2: null,
    isLoad: false
}
export const getListProductShopee = createAsyncThunk(
    'product/getListProductV2',
    async (idweb) => {
        try {
            const response = await http.get(
                `/list-product-shopee?idw=${idweb}`
            );
            return response.data.data;
        } catch (error) {
            throw new Error("Có lỗi xảy ra trong quá trình kết nối");
        }
    }
);
const getProductShopee = createSlice({
    name: "getProductShopee",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getListProductShopee.pending, (state) => {
                state.isLoad = true;
            })
            .addCase(getListProductShopee.fulfilled, (state, action) => {
                state.listBotav2 = action.payload
                state.isLoad = false;
            })
            .addCase(getListProductShopee.rejected, (state, action) => {
                state.isLoad = false;
                // state.eroi = action.error.message;
            })


    },
});

export default getProductShopee.reducer